module.exports = __webpack_public_path__ + "img/icon_map_car_dw.cad6059c.png";